/** Avatar mặc định trên MinIO (user-default.jpg). */
export const DEFAULT_AVATAR_URL =
  "https://ees-sol.site/media/uploads/avatars/user-default.jpg"
